module.exports = __webpack_public_path__ + "static/media/tidal.86797ff7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/tidal.png
 ** module id = 439
 ** module chunks = 0
 **/